// extracted by mini-css-extract-plugin
export default {"boxLayout":"BoxLayout_boxLayout__yrkop"};